import { useMemo } from 'react';

import type { SankeyProps } from '../sankey.model';

import { makeSankeyRootData } from './make-sankey-root-data';

type UseSankeyOptions = Pick<SankeyProps, 'options' | 'activeControls' | 'params' | 'data'>;

const useSankey = ({ activeControls, options, params, data }: UseSankeyOptions) => {
    const rootData = useMemo(
        () => makeSankeyRootData({ activeControls, options, params, data }),
        [activeControls, options, params, data],
    );
    const { nodeWidth, nodePadding, colorStrategy, showSourceLabels, showTargetLabels } = options ?? {};

    return {
        rootData,
        nodeWidth,
        nodePadding,
        colorStrategy,
        showSourceLabels,
        showTargetLabels,
    };
};

export { useSankey };
